import ScoringRequestDetailsContainer from './ScoringRequestDetails.container';

export default ScoringRequestDetailsContainer;
